module.exports = "\r\n.row span{\r\n      color:blue;\r\n}\r\n\r\nnav{\r\n      margin-top: 20px;\r\n      margin-bottom: 10px;\r\n}\r\n\r\n.table-responsive{\r\n      margin-top: 20px;\r\n}\r\n\r\n.row:nth-child(even){\r\n     background-color: #eaeaea;\r\n     margin-top: 10px;\r\n     margin-bottom: 10px;\r\n     padding-top: 10px;\r\n     padding-bottom: 10px;\r\n}\r\n\r\n.border{\r\n      margin: 5px 25px;\r\n      border: 1px solid gray;\r\n      padding: 15px;\r\n}\r\n\r\n.error-msg span{\r\n      color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/FIR/fir-form/fir-form.component.css
// module id = ./src/app/FIR/fir-form/fir-form.component.css
// module chunks = main